import * as Mod1 from "./discourse/components/vote-box";
import * as Mod2 from "./discourse/components/vote-button";
import * as Mod3 from "./discourse/components/vote-count-trigger";
import * as Mod4 from "./discourse/components/vote-count";
import * as Mod5 from "./discourse/connectors/header-topic-info__before/header-topic-voting.gjs";
import * as Mod6 from "./discourse/connectors/topic-title/topic-title-voting.gjs";
import * as Mod7 from "./discourse/connectors/user-activity-bottom/user-voted-topics.gjs";
import * as Mod8 from "./discourse/feature-voting-route-map";
import * as Mod9 from "./discourse/initializers/discourse-topic-voting";
import * as Mod10 from "./discourse/initializers/topic-voting-admin-plugin-configuration-nav";
import * as Mod11 from "./discourse/pre-initializers/extend-category-for-voting";
import * as Mod12 from "./discourse/pre-initializers/transformers";
import * as Mod13 from "./discourse/routes/user-activity/votes";
const compatModules = {
  "discourse/components/vote-box": Mod1,
  "discourse/components/vote-button": Mod2,
  "discourse/components/vote-count-trigger": Mod3,
  "discourse/components/vote-count": Mod4,
  "discourse/connectors/header-topic-info__before/header-topic-voting": Mod5,
  "discourse/connectors/topic-title/topic-title-voting": Mod6,
  "discourse/connectors/user-activity-bottom/user-voted-topics": Mod7,
  "discourse/feature-voting-route-map": Mod8,
  "discourse/initializers/discourse-topic-voting": Mod9,
  "discourse/initializers/topic-voting-admin-plugin-configuration-nav": Mod10,
  "discourse/pre-initializers/extend-category-for-voting": Mod11,
  "discourse/pre-initializers/transformers": Mod12,
  "discourse/routes/user-activity/votes": Mod13,
};
export default compatModules;
